import { Link } from "react-router-dom";

const footerColumns = [
  {
    title: "浏览",
    links: [
      { label: "首页", to: "/" },
      { label: "电影频道", to: "/category?type=movie" },
      { label: "电视剧频道", to: "/category?type=tv" },
      { label: "热门排行", to: "/category?sort=hot" },
    ],
  },
  {
    title: "发现",
    links: [
      { label: "影视专题", to: "/#topics" },
      { label: "搜索影视", to: "/search" },
      { label: "经典回顾", to: "/category?sort=rating" },
      { label: "关于我们", to: "/about" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="w-full bg-primary-900 text-background-100">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-14">
        <div className="flex flex-col gap-10 lg:flex-row lg:justify-between">
          <div className="max-w-sm">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-background-50">
                <i className="ri-clapperboard-fill text-xl"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">
                色色影院
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-100/70">
              汇聚海量电影与电视剧内容，按类型、地区、年份快速筛选，帮助你轻松找到想看的故事。
            </p>
            <p className="mt-4 text-xs text-background-100/50">
              本站为演示站点，所有影视名称、导演、主演及评分均为虚构示例。
            </p>
          </div>

          <div className="flex flex-wrap gap-12 md:gap-20">
            {footerColumns.map((column) => (
              <div key={column.title}>
                <h4 className="text-sm font-semibold text-background-50">
                  <span>{column.title}</span>
                </h4>
                <ul className="mt-4 space-y-3">
                  {column.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.to}
                        className="text-sm text-background-100/70 transition-colors hover:text-accent-400"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-50/15 pt-6 text-xs text-background-100/60 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 色色影院 · 内容仅作展示演示</p>
          <div className="flex flex-wrap gap-x-5 gap-y-2">
            <Link to="/about" className="transition-colors hover:text-accent-400">
              隐私政策
            </Link>
            <Link to="/about" className="transition-colors hover:text-accent-400">
              版权声明
            </Link>
            <Link to="/about" className="transition-colors hover:text-accent-400">
              联系我们
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}